module.exports = __webpack_public_path__ + "img/createStatus.6b7a06d7.png";